/** The representation of a zip code based geographic area. */
export default interface Zip {
  /** The zip code's string based identifier. */
  zipCode: string;

  /** The SSA that contains the majority of the zip code. */
  primaryCountySSA: string;

  /** The classification when measured via population density. */
  popDensityZipClass: ZipClass;

  /** The classification when measured via the census. */
  censusZipClass: ZipClass;

  /** The classification when measured via the census. */
  countySSA: ZipClass;

  name: string;

  area: number;
  minLatitude: number;
  minLongitude: number;
  maxLatitude: number;
  maxLongitude: number;
  centroidLatitude: number;
  centroidLongitude: number;
  labelLatitude: number;
  labelLongitude: number;

  isPrimaryCounty: boolean;
  isLegacy: boolean;
  enclosingZip: string;
}

interface ZipLite {
  // all the counties this zip is part of, including the primary
  countySSAs: string[];
  name: string;
  primaryCountySSA: string;
  zipCode: string;
}

/** The classification for a zip code. Measured in a variety of ways. */
enum ZipClass {
  Unknown = "Unknown",
  Rural = "Rural",
  Suburban = "Suburban",
  Urban = "Urban",
}

export { ZipClass, ZipLite };
